import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import classNames from 'classnames';

import { metrics } from '../../services/metrics';
import { priceDivide } from '../../services/priceDivide';

import './MetricsList.scss';

class MetricsList extends Component {
  get metrics() {
    const formParams = this.props.formParams;
    const { currentLang } = this.props;

    return (
      metrics.map((metric) => {
        const smallName = metric.smallName[currentLang] || metric.smallName;
        const fullName = metric.fullName[currentLang] || metric.fullName;
        const prefix = metric.prefix[currentLang] || metric.prefix;
        const classes = classNames({
          'metrics-list__item': true,
          'metrics-list__item_warning': parseFloat(metric.value(formParams), 10) < 0 && !metric.important,
          'metrics-list__item_important': metric.important,
          'metrics-list__item_warning-and-important': parseFloat(metric.value(formParams), 10) < 0 && metric.important
        });

        const value = parseFloat(metric.value(formParams));

        return (
          <div className={classes} key={`metrics-list-item-${metric.id}`}>
            <div className="metrics-list__item-name">
              { fullName }
              <br/>
              { smallName }
            </div>
            <div className="metrics-list__item-value">
              {
                Number.isFinite(value) ?
                <React.Fragment>
                  { priceDivide(value) } <span className="metrics-list__item-value-suffix">{ prefix }</span>
                </React.Fragment>
                :
                <React.Fragment>
                  -
                </React.Fragment>
              }
            </div>
          </div>
        )
      })
    )
  }

  render() {
    return (
      <div className="metrics-list">
        { this.metrics }
      </div>
    )
  }
}

function mapStateToProps(state) {
  const formParams = getFormValues('profit')(state) || {};
  const { language } = state;

  return {
    currentLang: language.current,
    formParams
  };
}

export default connect(mapStateToProps)(MetricsList);


// WEBPACK FOOTER //
// ./src/components/MetricsList/MetricsList.js